import React from 'react'
import FeaturedContent from './FeaturedContent'
import Footer from './Footer'
import Header from './Header'
import Home from './Home'
import PageHeader from './PageHeader'
import ReferOverview from './ReferOverview'

class App extends React.Component {// eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        {typeof window !== 'undefined' && window.location.search ? <PageHeader title="Indique parceiros" /> : <PageHeader homePage="true" title="Indique parceiros e ganhe desconto nas mensalidades do Gravíttem" />}
        <div style={{ flex: 1 }} className="section--tight">
          {/**  {this.props.children}   * */}
          <div className="container">
            {typeof window !== 'undefined' && window.location.search ?
              <ReferOverview />
              : <Home />}
          </div>

        </div>
        <FeaturedContent
          tagline="Junte-se aos mais de 400 clientes espalhados no Brasil inteiro que utilizam o Gravíttem"
          form
          singleColumn
        />
        <Footer />
      </div>
    )
  }
}


export default App



// WEBPACK FOOTER //
// ./client/components/App.js